import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/bradwestfall/Desktop/ReactTraining/Projects/monorepo/reacttraining.com/src/page-templates/DefaultMarkdownPage.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "diversity-and-inclusion-at-react-training"
    }}><a parentName="h1" {...{
        "href": "#diversity-and-inclusion-at-react-training",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`Diversity and Inclusion at React Training`}</h1>
    <p>{`Our events, and the greater development community, are better when people from all backgrounds are represented. To encourage and support underrepresented groups we have the React Training diversity program.`}</p>
    <p>{`10% of our tickets are discounted ~50% and available for people who meet any of these criteria:`}</p>
    <ul>
      <li parentName="ul">{`People of color`}</li>
      <li parentName="ul">{`Indigenous persons`}</li>
      <li parentName="ul">{`People with disabilities`}</li>
      <li parentName="ul">{`People who identify as LGBTQIA+`}</li>
      <li parentName="ul">{`Women and non-binary people`}</li>
      <li parentName="ul">{`Veterans and new graduates just beginning their tech careers`}</li>
      <li parentName="ul">{`Full-time students`}</li>
      <li parentName="ul">{`People who work for nonprofit/educational/government institution with limited funds`}</li>
      <li parentName="ul">{`People who are 55 years old or older`}</li>
      <li parentName="ul">{`People who are currently unemployed / underemployed`}</li>
      <li parentName="ul">{`People experiencing temporary financial hardship`}</li>
      <li parentName="ul">{`To receive a discount, `}<a parentName="li" {...{
          "href": "https://forms.gle/BfksjTYKqSi3X4UF9"
        }}>{`please fill out this form`}</a>{`.`}</li>
    </ul>
    <p>{`If you have any questions, please email us at `}<a parentName="p" {...{
        "href": "mailto:hello@reacttraining.com"
      }}>{`hello@reacttraining.com`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      